import React from "react";
import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";
import { Switch } from "@/components/ui/switch";

export function PartnersIntegrationEnabledRow({
  checked,
  disabled,
  onChange,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}) {
  const { t } = useTranslation();

  const id = "partners-integration-enabled";
  return (
    <div className="flex items-center gap-2">
      <Switch
        id={id}
        checked={checked}
        disabled={disabled}
        onCheckedChange={onChange}
      />
      <Label htmlFor={id} className="text-md">
        {t("billing.partnersIntegrationEnabled")}
      </Label>
    </div>
  );
}
